module.exports = __webpack_public_path__ + "assets/img/btn1-page.1e388876.png";